import { LocationOn, WorkOutline } from "@mui/icons-material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import SchoolIcon from "@mui/icons-material/School";
import SearchIcon from "@mui/icons-material/Search";
import ShareIcon from "@mui/icons-material/Share";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import {
  Alert,
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Pagination,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import {
  createJob,
  deleteJob,
  filterJobs,
  generateAISkills,
  generateJobDescription,
  getApplicants,
  getPostedJobs,
  getSingleJobDesc,
  getSinglePostedJob,
  updateJob,
} from "../../../../Redux/Reducers/JobReducer";
import JobOpenings from "./JobOpenings";
import ClearIcon from "@mui/icons-material/Clear";
import { useQuantityContext } from "../../../QuantityContext";
import { DeleteLightBox } from "../ProfessionalProfile";
import { ShareProfile } from "../ProfileConnectionComponents";
import UpcomingEvents from "./UpcomingEvents";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useProfileContext } from "../../../ProfileDetailContext";
import EditIcon from "@mui/icons-material/Edit";
import GroupsIcon from "@mui/icons-material/Groups";
import PostingJobModal from "./PostingJobModal";
import ProfessionalCalender from "./ProfessionalCalender";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import CompanySelectionModal from "../CompanySelectionModal";
import FilterComponent from "./FilterComponent";
import CandidatePagination from "./CandidatePagination";
import GlobalSearchCandidates from "../GlobalSearchCandidates";
import {
  getCompanyIdFromUserType,
  getEnterpriseEntityIdFromUserType,
} from "../../../../utils/userTypeUtils";
import { filterCompaniesFromUserType } from "../../../../utils/filterUtil";
import { syncEnterpriseJobAPI } from "../../../../enterpriseApi";
import { getUserIdDetails } from "../../../../Redux/Reducers/OnboardingReducer";

import AllCardsSkeleton from "../../../LoadingSkeleton/AllCardsSkeleton";
import { motion } from "framer-motion";
import JobsCardsSkeleton from "../../../LoadingSkeleton/JobsCardsSkeleton";
import { Helmet } from 'react-helmet';



const AllJobs = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isInitialMount = useRef(true);
  // const [jobs, setJobs] = useState([]); // To store the job data
  // const [loading, setLoading] = useState(true); // To handle loading state
  const [error, setError] = useState(null); // To handle errors
  const [editingJob, setEditingJob] = useState(null); // The job being edited
  const [saving, setSaving] = useState(false); // To handle saving state
  // const [logourl, setLogourl] = useState({}); // Initialize as an empty object instead of an empty string
  // const [isRecruiter, setIsRecruiter] = useState(null);
  // const [filteredJobs, setFilteredJobs] = useState([]); // Filtered jobs
  const [refreshJobs, setRefreshJobs] = useState(false);
  // const [viewMode, setViewMode] = useState("grid");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [showSearchBar, setShowSearchBar] = useState(false); // To show/hide the search bar
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const objectId = localStorage.getItem("objectId");
  const { postedJobs, loading, viewMode } = useSelector(
    (state) => state.jobs || {}
  );
  const JobsData = useSelector((state) => state?.jobs?.postedJobsData);
  // console.log("JobsData", JobsData);
  const postedJobsData = useSelector(
    (state) => state?.jobs?.postedJobsData?.posted_jobs
  );

  const allJobs = useSelector((state) => state.jobs?.allJobs);
  const filteredData = useSelector((state) => state.jobs?.filteredJobs);
  const [searchTerm, setSearchTerm] = useState("");
  const [jobsToDisplay, setJobsToDisplay] = useState(filteredData) || [];
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [email, setEmail] = useState("");
  const [emailLoading, setEmailLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [jobToDelete, setJobToDelete] = useState(null);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [noResults, setNoResults] = useState(false);
  const filters = useSelector((state) => state?.jobs?.filters);
  const { openSnackbar } = useQuantityContext();
  const [searchParams] = useSearchParams();
  const deptTypeFilter = searchParams.get("dept_type");
  const [isPostingModalOpen, setIsPostingModalOpen] = useState(false);
  const [showCompanySelection, setShowCompanySelection] = useState(false);
  const [isLoadingDescription, setIsLoadingDescription] = useState(false);
  const [isLoadingSkills, setIsLoadingSkills] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const selectedCompany =
    useSelector((state) => state?.jobs?.selectedCompany) || {};
  const [appliedFilters, setAppliedFilters] = useState({});
  const [appliedSearch, setAppliedSearch] = useState("");
  const [hiringData, setHiringData] = useState({
    role: "",
    company_name: "",
    company_url: "",
    company_location: "",
    about_company: "",
    dept_type: "",
    emp_type: "",
    edu_level: "",
    experience: "",
    salary: "",
    location: "",
    mode: "",
    skills: [],
    // job_summary: "",
    // responsibility: [],
    qualifications: [],
    // perks: [],
    // pre_requisites: [],
    no_of_rounds: "",
    no_of_open_positions: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 50 },
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true); // Trigger animation after a delay
    }, 100); // Adjust delay as needed
    return () => clearTimeout(timer);
  }, []);

  // console.log("hiringData-NNN", hiringData);
  // const { totalPages, currentPage } = useSelector((state) => state.jobs);
  // console.log("jobsToDisplay", jobsToDisplay);

  //  console.log("hiringDataVVV", hiringData)

  const handleApplyFilters = (search, filters) => {
    // Preserve the filter state by merging with existing filters
    setAppliedFilters((prevFilters) => ({
      ...prevFilters,
      ...filters,
    }));
    setAppliedSearch(search);
    setPageCount(0);
  };

  const handleClearFilters = () => {
    setAppliedFilters({});
    setAppliedSearch("");
    setPageCount(0);
  };
  const handlePage = (count) => {
    setPageCount(count);
  };

  const params = useMemo(
    () => ({
      company: selectedCompany?.company_name,
      department: appliedFilters?.dept_type,
      role: appliedFilters?.role,
      location: appliedFilters?.location,
      skills: appliedFilters?.skills,
      mode: appliedFilters?.mode,
      sort_by: appliedFilters?.sort_by,
      sort_order: appliedFilters?.sort_order,
      page: pageCount,
      search: appliedSearch,
    }),
    [pageCount, appliedFilters, appliedSearch]
  );

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true); // Show loader
      try {
        await dispatch(getPostedJobs(params)); // Fetch jobs
      } catch (error) {
        console.error("Error fetching jobs:", error);
      } finally {
        setIsLoading(false); // Hide loader
      }
    };

    fetchData();
  }, [params]);

  const handlePageChange = (_, newPage) => {
    setPageCount(newPage - 1);
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [currentStep, setCurrentStep] = useState(1);
  const generatedSkills = useSelector((state) => state?.jobs?.generatedSkills);
  const [localGeneratedSkills, setLocalGeneratedSkills] =
    useState(generatedSkills);
  const [selectedChips, setSelectedChips] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [hiringInputValue, setHiringInputValue] = useState("");
  const { currentPage, totalPages } = useSelector((state) => state.jobs);
  const [page, setPage] = useState(0);
  const [editingDescription, setEditingDescription] = useState(false);
  const { ExperienceList } = useProfileContext();
  const companyLogo = ExperienceList[0]?.companylogo?.data || "";
  const ProfessionalExperience = useSelector(
    (state) => state?.ProfileArray?.experienceData?.data
  );
  const rawUserTypeDetails = useSelector((state) => state?.onboarding?.userTypeDetails);
  const userTypeDetails =
    (rawUserTypeDetails?.data && Array.isArray(rawUserTypeDetails.data))
      ? rawUserTypeDetails.data
      : (Array.isArray(rawUserTypeDetails) ? rawUserTypeDetails : []);

  useEffect(() => {
    if (
      (!userTypeDetails || userTypeDetails.length === 0) &&
      localStorage.getItem("objectId")
    ) {
      dispatch(getUserIdDetails());
    }
  }, [dispatch, userTypeDetails]);

  const enterpriseCompanies = filterCompaniesFromUserType(
    rawUserTypeDetails || userTypeDetails,
    ProfessionalExperience
  );
  const [hiringModalOpen, setHiringModalOpen] = useState(false);


  useEffect(() => {
    // Merge generatedSkills and hiringData.skills, removing duplicates
    const mergedSkills = Array.from(
      new Set([...(generatedSkills || []), ...(hiringData.skills || [])])
    );
    setLocalGeneratedSkills(mergedSkills);
  }, [generatedSkills, hiringData.skills]);

  useEffect(() => {
    if (editingJob?.skills) {
      const parsedSkills = parseSkillsArray(editingJob.skills);
      setSelectedChips(parsedSkills);
      setLocalGeneratedSkills(parsedSkills);
    }
  }, [editingJob]);

  // Add these handler functions

  const handleBack = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const handleNext = async () => {
    try {
      if (currentStep === 1) {
        // setIsLoadingSkills(true);
        const jobData = {
          role: hiringData.role,
          dept_type: hiringData.dept_type,
          experience: hiringData.experience,
        };
        await dispatch(generateAISkills(jobData));
      }

      if (currentStep === 2) {
        setIsLoadingDescription(true);
        const jobData = {
          role: hiringData.role,
          company_name: hiringData.company_name,
          dept_type: hiringData.dept_type,
          experience: hiringData.experience,
        };

        const response = await dispatch(generateJobDescription(jobData));

        if (response?.payload?.statusCode === 200) {
          const generatedContent = response.payload.data;
          setHiringData((prev) => ({
            ...prev,
            job_summary: generatedContent.job_summary || prev.job_summary,
            responsibility: Array.isArray(generatedContent.responsibilities)
              ? generatedContent.responsibilities
              : cleanNestedJSON(generatedContent.responsibility),
            qualifications: Array.isArray(generatedContent.qualifications)
              ? generatedContent.qualifications
              : cleanNestedJSON(generatedContent.qualifications),
            about_company: generatedContent.about_company || prev.about_company,
          }));
        }
      }
      setCurrentStep((prev) => prev + 1);
    } catch (error) {
      console.error("Error:", error);
      openSnackbar("Failed to generate content", "error");
    } finally {
      // setIsLoadingSkills(false);
      setIsLoadingDescription(false);
    }
  };
  const handleChipToggle = (chip) => {
    setSelectedChips((prev) => {
      const newSelected = prev.includes(chip)
        ? prev.filter((item) => item !== chip)
        : [...prev, chip];

      // Update hiringData skills
      setHiringData((prev) => ({
        ...prev,
        skills: newSelected,
      }));

      return newSelected;
    });
  };

  const handleHiringChipDelete = (chip) => {
    setLocalGeneratedSkills((prev) => prev.filter((item) => item !== chip));
    setSelectedChips((prev) => prev.filter((item) => item !== chip));
    setEditingJob((prev) => ({
      ...prev,
      skills:
        typeof prev?.skills === "string"
          ? prev.skills
              .split(",")
              .map((s) => s.trim())
              .filter((s) => s !== chip)
              .join(", ")
          : Array.isArray(prev?.skills)
          ? prev.skills.filter((skill) => skill !== chip)
          : [],
    }));
  };

  const handleAddChip = (chip) => {
    if (!localGeneratedSkills.includes(chip)) {
      setLocalGeneratedSkills((prev) => [...prev, chip]);
      setSelectedChips((prev) => [...prev, chip]);
    }
  };

  const handleChipDelete = (chipToDelete) => {
    setLocalGeneratedSkills((prev) =>
      prev.filter((chip) => chip !== chipToDelete)
    );
    setSelectedChips((prev) => prev.filter((chip) => chip !== chipToDelete));
  };

  const handleSuccess = (message, severity = "success", autoClose = 6000) => {
    openSnackbar(message, severity, autoClose);
  };

  const handleFailure = (message, severity = "error", autoClose = 6000) => {
    openSnackbar(message, severity, autoClose);
  };

  useEffect(() => {
    if (deptTypeFilter) {
      // Update the filters state when dept_type parameter is present
      setSelectedFilters((prev) => ({
        ...prev,
        dept_type: deptTypeFilter,
      }));

      // Filter jobs by department type
      const filtered = postedJobsData?.filter(
        (job) => job.dept_type?.toLowerCase() === deptTypeFilter?.toLowerCase()
      );
      setJobsToDisplay(filtered);
    }
  }, [deptTypeFilter, postedJobsData]);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    // Reset to original data when search is empty
    if (!term.trim()) {
      setFilteredJobs(jobsToDisplay);
      return;
    }

    const filtered = jobsToDisplay?.filter(
      (job) =>
        job.role?.toLowerCase().includes(term) ||
        job.company_name?.toLowerCase().includes(term) ||
        job.location?.toLowerCase().includes(term)
      // job.skills?.toLowerCase().includes(term)
    );
    setFilteredJobs(filtered);
  };

  // console.log("jobsToDisplay", jobsToDisplay);

  const [shareProfileConfig, setShareProfileConfig] = useState({
    open: false,
    onClose: undefined,
    qrCodeUrl: "",
    qrCodeLogo: undefined,
    showQr: true,
    isDownload: false,
    profileType: "",
    handleSuccess: handleSuccess,
    handleFailure: handleFailure,
  });

  const handleShareJob = (job, event) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedJob(job);
    setShareDialogOpen(true);
  };

  // Social media share handlers
  const handleSocialShare = (platform) => {
    const jobUrl = `${window.location.origin}/job-description/${selectedJob.id}`;
    const text = `Check out this job: ${selectedJob.title} at ${selectedJob.company_name}`;

    let shareUrl = "";
    switch (platform) {
      case "whatsapp":
        shareUrl = `https://wa.me/?text=${encodeURIComponent(
          text + " " + jobUrl
        )}`;
        break;
      case "linkedin":
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          jobUrl
        )}`;
        break;
      case "telegram":
        shareUrl = `https://t.me/share/url?url=${encodeURIComponent(
          jobUrl
        )}&text=${encodeURIComponent(text)}`;
        break;
      default:
        break;
    }
    window.open(shareUrl, "_blank");
  };

  const handleEmailSend = async () => {
    try {
      setEmailLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/mail/share-job`,
        {
          jobId: selectedJob.id,
          email: email,
        },
        { headers }
      );

      if (response.data.status === "SUCCESS") {
        // alert('Job shared successfully!');
        openSnackbar("Job shared successfully!", "success");
        setEmail("");
      }
    } catch (error) {
      console.error("Error sharing job:", error);
      // alert('Failed to share job');
      openSnackbar("Failed to share job", "error");
    } finally {
      setEmailLoading(false);
    }
  };

  // Copy link handler
  const handleCopyLink = () => {
    const jobUrl = `${window.location.origin}/job-description/${selectedJob.id}`;
    navigator.clipboard.writeText(jobUrl);
    // alert('Link copied to clipboard!');
  };

  const popupRef = useRef(null);

  const [selectedFilters, setSelectedFilters] = useState({
    dept_type: deptTypeFilter || "",
    experience: "",
    edu_level: "",
    role: "",
    location: "",
    mode: "",
  });

  const headers = {
    "x-api-key": process.env.REACT_APP_API_KEY,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };

  const jobListings = Array(20).fill({
    id: 36,
    company_name: "Dalocal Technologies",
    company_location: "Bangalore",
    role: "Frontend Developer",
    location: "Hyderabad",
    mode: "On-site",
    experience: "3-5 Years",
    salary: "5,00,000-10,00,000",
    status: "open",
  });

  useEffect(() => {
    // Auto-trigger filter when filters change
    dispatch(filterJobs(selectedFilters));
  }, [selectedFilters, dispatch]);

  const handleFilterChange = (filterType, value) => {
    const newFilters = { ...selectedFilters };

    // Toggle filter value
    if (selectedFilters[filterType] === value) {
      newFilters[filterType] = ""; // Remove filter if same value clicked
    } else {
      newFilters[filterType] = value; // Add new filter value
    }

    setSelectedFilters(newFilters);
    dispatch(filterJobs(newFilters));
  };

  const handleJobDelete = (jobId) => {
    setJobToDelete(jobId);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await dispatch(deleteJob(jobToDelete));
      if (response?.payload?.statusCode === 200) {
        setJobsToDisplay((prev) =>
          prev?.filter((job) => job?.id !== jobToDelete)
        );
        // setSnackbar({
        //   open: true,
        //   message: 'Job deleted successfully',
        //   severity: 'success'
        // });
        openSnackbar("Job deleted successfully", "success");
      }
    } catch (error) {
      // setSnackbar({
      //   open: true,
      //   message: error.message || 'Failed to delete job',
      //   severity: 'error'
      // });
      openSnackbar("Failed to delete job", "error");
    }
    setShowDeleteModal(false);
    setJobToDelete(null);
  };

  // Add this new function to handle step navigation
  const handleEditClick = (targetStep) => {
    setCurrentStep(targetStep);
  };

  const handleEditResponseClick = async () => {
    try {
      setIsLoadingDescription(true);
      const jobData = {
        role: hiringData.role,
        company_name: hiringData.company_name,
        dept_type: hiringData.dept_type,
        experience: hiringData.experience,
      };

      const response = await dispatch(generateJobDescription(jobData));

      if (response?.payload?.statusCode === 200) {
        const generatedContent = response.payload.data;
        setHiringData((prev) => ({
          ...prev,
          job_summary: generatedContent.job_summary || prev.job_summary,
          responsibility: Array.isArray(generatedContent.responsibility)
            ? generatedContent.responsibility
            : cleanNestedJSON(generatedContent.responsibility),
          qualifications: Array.isArray(generatedContent.qualifications)
            ? generatedContent.qualifications
            : cleanNestedJSON(generatedContent.qualifications),
          about_company: generatedContent.about_company || prev.about_company,
        }));
        openSnackbar("Job description generated successfully", "success");
      }
    } catch (error) {
      console.error("Error generating description:", error);
      openSnackbar("Failed to generate job description", "error");
    } finally {
      setIsLoadingDescription(false);
    }
  };

  const handleEditSkillClick = async () => {
    try {
      const jobData = {
        role: hiringData.role,
        dept_type: hiringData.dept_type,
        experience: hiringData.experience,
      };

      const response = await dispatch(generateAISkills(jobData));

      if (response?.payload?.statusCode === 200) {
        const generatedSkills = response.payload.data?.skills || [];
        setLocalGeneratedSkills(generatedSkills);
        setSelectedChips(generatedSkills);
        setHiringData((prev) => ({
          ...prev,
          skills: generatedSkills,
        }));
        openSnackbar("Skills generated successfully", "success");
      }
    } catch (error) {
      openSnackbar("Failed to generate skills", "error");
      console.error("Error generating skills:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditingJob((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

const renderPostedDate = (date) => {
  const postedDate = new Date(date);
  const now = new Date();
  const diffInMs = now - postedDate;

  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const diffInMonths = Math.floor(diffInDays / 30);
  const diffInYears = Math.floor(diffInDays / 365);

  if (diffInMinutes < 1) {
    return "just now";
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes}m ${diffInMinutes === 1 ? "" :""} ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours}h ${diffInHours === 1 ? "" : ""} ago`;
  } else if (diffInDays === 1) {
    return "1d ago";
  } else if (diffInDays < 30) {
    return `${diffInDays}d ago`;
  } else if (diffInMonths < 12) {
    return `${diffInMonths}m ${diffInMonths === 1 ? "" : ""} ago`;
  } else {
    return `${diffInYears}y ${diffInYears === 1 ? "" : ""} ago`;
  }
};


  const formatSalary = (salary) => {
    if (!salary) return "Not Specified"; // If salary is null, undefined, or empty string, return "Not Specified"

    // Check if the salary is already in 'k' format (e.g., '50k', '150k')
    if (/^\d+(\.\d+)?k$/.test(salary)) {
      return salary; // If it's in 'k' format, return the salary as is
    }

    // Check if the salary is a range (e.g., "10000-20000")
    const salaryParts = salary.split("-");

    if (salaryParts.length === 2) {
      const minSalary = parseInt(salaryParts[0].replace(/,/g, ""));
      const maxSalary = parseInt(salaryParts[1].replace(/,/g, ""));

      // Check if both values are valid numbers
      if (isNaN(minSalary) || isNaN(maxSalary)) {
        return "Not Specified"; // If either value is NaN, return "Not Specified"
      }

      // Convert salary range to 'k' format
      return `${minSalary / 1000}k - ${maxSalary / 1000}k`;
    } else {
      const salaryInK = parseInt(salary.replace(/,/g, ""));

      // If the salary is not a valid number, return "Not Specified"
      if (isNaN(salaryInK)) {
        return "Not Specified";
      }

      return `${salaryInK / 1000}k`; // If it's a single salary, convert to 'k' format
    }
  };

  const handleFilterIconClick = () => {
    console.log(showFilterDropdown);
    setShowFilterDropdown(!showFilterDropdown);
  };

  const parseSkillsArray = (data) => {
    if (!data) return [];

    try {
      // First attempt to parse as JSON
      const parsedData = JSON.parse(data);
      return Array.isArray(parsedData) ? parsedData : [];
    } catch (error) {
      // If JSON parsing fails, check if it's a comma-separated string
      if (typeof data === "string") {
        return data?.split(",")?.map((skill) => skill.trim());
      }
      // If it's already an array
      if (Array.isArray(data)) {
        return data;
      }
      return [];
    }
  };

  const handleAnalyticClick = async (jobId) => {
    try {
      await dispatch(getSinglePostedJob(jobId)).unwrap();
      await dispatch(getApplicants({ job_id: jobId })).unwrap();
      navigate("/recruitment-Status");
    } catch (error) {
      console.error("Error fetching job/applicants:", error);
      // Optionally show error feedback to user
    }
  };

  // console.log("parseSkillsArray", localGeneratedSkills)

  const menuOptions = {
    "Department Type": [
      "Human Resources (HR)",
      "Finance & Accounting",
      "Marketing",
      "Sales",
      "Customer Support",
      "Operations",
      "Legal & Compliance",
      "Administrative",
      "Information Technology (IT)",
      "Software Development",
      "Data & Analytics",
      "Product Management",
      "Medical & Clinical",
      "Pharmacy",
      "Research & Development (R&D)",
      "Production & Manufacturing",
      "Engineering",
      "Quality Assurance (QA)",
      "Academic Affairs",
      "Student Affairs",
      "Training & Development",
      "Public Relations (PR)",
      "Procurement & Purchasing",
      "Supply Chain & Logistics",
    ],
    "Employment Type": [
      "Full-time/ Permanent",
      "Part-time",
      "Freelance",
      "Internship",
      "Trainee",
    ],
    "Education Type": [
      "Undergraduate",
      "10th/SSLC/SCC",
      "12th/PUC/HSC",
      "Postgraduate",
      "Higher Education",
      "Any Graduate",
    ],
    "Experience Range": [
      "0-1 year",
      "1-2 years",
      "2-4 years",
      "4-6 years",
      "6-8 years",
      "8-10 years",
      "10-15 years",
      "15-20 years",
      "20+ years",
    ],
    "Salary Range": [
      "Less than 2,00,000",
      "2,00,000-5,00,000",
      "5,00,000-10,00,000",
      "10,00,000-15,00,000",
      "15,00,000-20,00,000",
      "20,00,000-30,00,000",
      "35,00,000-50,00,000",
      "50,00,000-1,00,00,000",
      "Above-1,00,00,000",
    ],
    "Work Location": ["Bangalore", "Hyderabad", "Chennai", "Delhi", "Kochi"],
    "Work Mode": ["On-site", "Hybrid", "Remote"],
  };

  const handleHiringAddChip = (newChip) => {
    if (
      newChip &&
      !localGeneratedSkills.includes(newChip) &&
      newChip.trim() !== ""
    ) {
      // Add to local skills
      setLocalGeneratedSkills((prev) => [...prev, newChip]);
      // Select the chip immediately
      setSelectedChips((prev) => [...prev, newChip]);
      // Update hiringData.skills
      setHiringData((prev) => ({
        ...prev,
        skills: [...(prev.skills || []), newChip],
      }));
      setHiringInputValue("");
    }
  };

  const handleJObSearch = (event) => {
    const keyword = event.target.value.toLowerCase();
    setSearchKeyword(keyword);

    if (!keyword.trim()) {
      setFilteredJobs(jobsToDisplay);
      setNoResults(false);
      return;
    }

    const filtered = jobsToDisplay?.filter(
      (job) =>
        job.role?.toLowerCase().includes(keyword) ||
        job.company_name?.toLowerCase().includes(keyword) ||
        job.location?.toLowerCase().includes(keyword) ||
        job.skills?.toLowerCase().includes(keyword)
    );

    setFilteredJobs(filtered);
    setNoResults(filtered.length === 0);
  };

  const updateShareProfileConfig = (newConfig) => {
    setShareProfileConfig((prev) => ({
      ...prev,
      ...newConfig,
    }));
  };

  const handleJobShare = (job) => {
    setSelectedJob(job);
    updateShareProfileConfig({
      open: true,
      onClose: () =>
        setShareProfileConfig((prev) => ({ ...prev, open: false })),
      qrCodeUrl: `${process.env.REACT_APP_CARD_URL}/job-description/${job.id}`,
      showQr: false,
      profileType: "Job",
      handleSuccess,
      handleFailure,
      shareData: {
        title: job.role ? `${job.role} at ${job.company_name || 'a company'}` : 'Job Opportunity',
        description: [
          job.location && `📍 ${job.location}`,
          job.experience && `💼 ${job.experience}`,
          job.edu_level && `🎓 ${job.edu_level}`
        ].filter(Boolean).join(' | ') || 'Check out this job opportunity',
        image: job.company_logo || 'default_job_image_url',
        url: `${process.env.REACT_APP_CARD_URL}/job-description/${job.id}`,
        company: job.company_name,
        location: job.location
      }
    });
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const deptTypeFilter = searchParams.get("dept_type");
    const statusFilter = searchParams.get("status");

    if (!postedJobsData?.length) return;

    let filtered = [...postedJobsData];

    // Apply status filter if present
    if (statusFilter) {
      filtered = filtered?.filter(
        (job) => job.status?.toLowerCase() === statusFilter?.toLowerCase()
      );
    }

    // Apply department type filter if present
    if (deptTypeFilter) {
      filtered = filtered?.filter(
        (job) => job.dept_type?.toLowerCase() === deptTypeFilter?.toLowerCase()
      );
    }

    // Apply other filters from the filter panel
    if (selectedFilters) {
      Object.entries(selectedFilters).forEach(([key, value]) => {
        if (value) {
          filtered = filtered?.filter(
            (job) => job[key]?.toLowerCase() === value?.toLowerCase()
          );
        }
      });
    }

    // Apply search term filter
    if (searchTerm) {
      filtered = filtered?.filter(
        (job) =>
          job.role?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          job.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          job.location?.toLowerCase().includes(searchTerm.toLowerCase())
        // job.skills?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setJobsToDisplay(filtered);
    setFilteredJobs(filtered);
  }, [postedJobsData, selectedFilters, searchTerm, deptTypeFilter]);

  const handleDescriptionChange = (field, value) => {
    setEditingJob((prev) => ({
      ...prev,
      [field]:
        field === "responsibility" || field === "qualifications"
          ? value.split("\n").filter((item) => item.trim()) // Convert text to array
          : value,
    }));
  };

  const cleanNestedJSON = (data) => {
    if (!data) return [];
    try {
      // If it's already an array, return it
      if (Array.isArray(data)) return data;

      // If it's a string, try to parse it
      let parsed = data;
      while (typeof parsed === "string") {
        try {
          parsed = JSON.parse(parsed);
        } catch {
          // If parsing fails, split by newlines or commas
          return parsed
            .split(/[\n,]/)
            .map((item) =>
              item
                .trim()
                .replace(/\\"/g, '"')
                .replace(/\\/g, "")
                .replace(/^\[|\]$/g, "")
                .replace(/^"|"$/g, "")
            )
            .filter(Boolean);
        }
      }
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch (error) {
      return typeof data === "string" ? [data] : [];
    }
  };

  const parseToArray = (data) => {
    if (!data) return [];
    try {
      const parsedData = JSON.parse(data);
      return Array.isArray(parsedData) ? parsedData : [];
    } catch (error) {
      return [data];
    }
  };

  const handleEditJobClick = (job, e) => {
    e.preventDefault();
    e.stopPropagation();

    // Transform job data to match hiring data format
    const transformedData = {
      id: job.id,
      role: job.role || "",
      company_name: job.company_name || "",
      company_url: job.company_url || "",
      company_location: job.company_location || "",
      company_logo: job.company_logo || "",
      dept_type: job.dept_type || "",
      emp_type: job.emp_type || "",
      edu_level: job.edu_level || "",
      experience: job.experience || "",
      salary: job.salary || "",
      location: job.location || "",
      mode: job.mode || "",
      skills: Array.isArray(job.skills)
        ? job.skills
        : typeof job.skills === "string"
        ? JSON.parse(job.skills)
        : [],
      // job_summary: job.job_summary || "",
      job_description_md: job.job_description_md || "",
      // responsibility: Array.isArray(job.responsibility)
      //   ? job.responsibility
      //   : typeof job.responsibility === "string"
      //   ? JSON.parse(job.responsibility)
      //   : [],
      qualifications: Array.isArray(job.qualifications)
        ? job.qualifications
        : typeof job.qualifications === "string"
        ? JSON.parse(job.qualifications)
        : [],
      // perks: Array.isArray(job.perks)
      //   ? job.perks
      //   : typeof job.perks === "string"
      //   ? JSON.parse(job.perks)
      //   : [],
      // pre_requisites: Array.isArray(job.pre_requisites)
      //   ? job.pre_requisites
      //   : typeof job.pre_requisites === "string"
      //   ? JSON.parse(job.pre_requisites)
      //   : [],
      // about_company: job.about_company || "",
      no_of_rounds: Number(job.no_of_rounds) || 1,
      no_of_open_positions: Number(job.no_of_open_positions) || 1,
    };

    setHiringData(transformedData);
    setSelectedChips(transformedData.skills);
    setLocalGeneratedSkills(transformedData.skills);
    setCurrentStep(1);
    // setIsPostingModalOpen(true);
    setHiringModalOpen(true);
  };

  // const handleKeyDown = (e) => {
  //   console.log("Key Pressed:", e.key);
  // };

  const handleCompanySelection = (selectedExperience) => {
    const companyId =
      selectedExperience.cid ||
      selectedExperience.uniqueId ||
      getCompanyIdFromUserType(
        userTypeDetails,
        selectedExperience.companyName || selectedExperience.company_name
      );
    const enterpriseCompanyId =
      selectedExperience.id ||
      selectedExperience.entityId ||
      getEnterpriseEntityIdFromUserType(
        userTypeDetails,
        selectedExperience.companyName || selectedExperience.company_name || companyId
      );

    const targetCompName = (selectedExperience.companyName || selectedExperience.company_name || "")?.trim()?.toLowerCase();
    const targetCid = (companyId || selectedExperience.cid || selectedExperience.uniqueId || "")?.toString()?.trim()?.toLowerCase();
    const targetLogo = (selectedExperience.companyLogo || selectedExperience.company_logo || "")?.trim();

    const matchedExp = (Array.isArray(ProfessionalExperience) ? ProfessionalExperience : []).find((exp) => {
      const expCid = (exp?.cid || exp?.uniqueId || exp?.company_id || "")?.toString()?.trim()?.toLowerCase();
      const expName = (exp?.company_name || exp?.companyName || "")?.trim()?.toLowerCase();
      const expLogo = (exp?.company_logo || exp?.companylogo?.data || "")?.toString()?.trim();

      if (expCid && targetCid && expCid === targetCid) return true;
      if (expName && targetCompName && expName === targetCompName) return true;
      if (expLogo && targetLogo && expLogo === targetLogo) return true;
      if (expName && targetCompName && (expName.includes(targetCompName) || targetCompName.includes(expName))) return true;
      return false;
    });

    let companyDomain =
      selectedExperience.company_domain ||
      selectedExperience.companyDomain ||
      selectedExperience.company_url ||
      selectedExperience.website ||
      matchedExp?.company_domain ||
      matchedExp?.companyDomain ||
      matchedExp?.website ||
      matchedExp?.company_url ||
      hiringData?.company_url ||
      "";

    if (!companyDomain && matchedExp?.company_email && matchedExp.company_email.includes("@")) {
      const emailDomain = matchedExp.company_email.split("@")[1]?.trim()?.toLowerCase();
      const publicProviders = ["gmail.com", "yahoo.com", "outlook.com", "hotmail.com", "icloud.com"];
      if (emailDomain && !publicProviders.includes(emailDomain)) {
        companyDomain = emailDomain;
      }
    }

    setHiringData((prev) => ({
      ...prev,
      company_name: selectedExperience.companyName || selectedExperience.company_name || "",
      company_url: companyDomain || prev?.company_url || "",
      company_location: selectedExperience.location || matchedExp?.location || prev?.company_location || "",
      emp_type: selectedExperience.employee_type || selectedExperience.role || matchedExp?.employee_type || prev?.emp_type || "",
      mode: selectedExperience.location_type || selectedExperience.location || matchedExp?.location_type || "Remote",
      company_logo: selectedExperience.companyLogo || selectedExperience.company_logo || matchedExp?.company_logo || "", // Add company logo
      company_id: companyId || "",
      enterprise_company_id: enterpriseCompanyId || undefined,
    }));
    setShowCompanySelection(false);
    setHiringModalOpen(true);
  };

  const currentExperiences =
    ProfessionalExperience?.filter(
      (exp) => exp.is_currently_working && exp.is_verified
    ) || [];

  const displayCompanies =
    enterpriseCompanies.length > 0 ? enterpriseCompanies : currentExperiences;

  const handlePostJobClick = () => {
    if (displayCompanies.length > 0) {
      setShowCompanySelection(true);
    } else {
      openSnackbar(
        "You need to be verified and currently employed to post a job",
        "warning"
      );
      // navigate("/myprofile");
    }
  };


  const handleSingleJobClick = (JobId, source = "posted-job") => {
    // dispatch(getSingleJobDesc(JobId));s
    dispatch(getApplicants({ job_id: JobId }));
    navigate(`/job-description/${JobId}`, { state: { source } });
  };

  const handleHiringInputChange = (e) => {
    // e.preventDefault();
    const { name, value } = e.target;
    console.log("handleHiring", name, value);

    if (name === "responsibility" || name === "qualifications") {
      setHiringData((prev) => ({ ...prev, [name]: value.split("\n") }));
    }
    else if (name === "job_description_md") {
      setHiringData((prev) => ({ ...prev, job_description_md: value }));
    } else {
      setHiringData((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleHiringSubmit = async () => {
    try {
      setSaving(true);

      const companyId =
        hiringData.company_id ||
        getCompanyIdFromUserType(userTypeDetails, hiringData.company_name);

      // Format the data for submission
      const formattedHiringData = {
        id: hiringData.id,
        data: {
          ...hiringData,
          company_id: companyId || hiringData.company_id || undefined,
          job_description_md: hiringData.job_description_md,
          skills: JSON.stringify(selectedChips),
          responsibility: JSON.stringify(
            Array.isArray(hiringData.responsibility)
              ? hiringData.responsibility
              : []
          ),
          qualifications: JSON.stringify(
            Array.isArray(hiringData.qualifications)
              ? hiringData.qualifications
              : []
          ),
          perks: JSON.stringify(
            Array.isArray(hiringData.perks) ? hiringData.perks : []
          ),
          pre_requisites: JSON.stringify(
            Array.isArray(hiringData.pre_requisites)
              ? hiringData.pre_requisites
              : []
          ),
          no_of_rounds: Number(hiringData.no_of_rounds),
          no_of_open_positions: Number(hiringData.no_of_open_positions),
        },
      };

      console.log("formattedHiringData", formattedHiringData.data);

      let response;
      if (hiringData.id) {
        response = await dispatch(updateJob(formattedHiringData.data));
      } else {
        response = await dispatch(createJob(formattedHiringData.data));
      }

      if (
        response?.payload?.statusCode === 200 ||
        response?.payload?.statusCode === 201
      ) {
        // Sync created job with Enterprise service (only for new job postings)
        if (!hiringData?.id) {
          const createdJobId =
            response?.payload?.data?.id ||
            response?.payload?.data?.jobId ||
            response?.payload?.data?.job_id ||
            response?.payload?.id ||
            response?.payload?.jobId ||
            (typeof response?.payload?.data === "number" ? response?.payload?.data : null);

          const enterpriseCompanyId =
            hiringData.enterprise_company_id ||
            getEnterpriseEntityIdFromUserType(
              userTypeDetails,
              hiringData.company_name || companyId
            );

          if (createdJobId && enterpriseCompanyId) {
            try {
              await syncEnterpriseJobAPI({
                jobId: createdJobId,
                companyId: enterpriseCompanyId,
                jobtype: hiringData.emp_type || "full-time/permanent",
              });
            } catch (syncErr) {
              console.error("Error syncing job with enterprise service:", syncErr);
            }
          }
        }

        openSnackbar(
          hiringData?.id
            ? "Job updated successfully!"
            : "Job created successfully!",
          "success"
        );

        // Reset states
        setHiringData({
          role: "",
          company_name: "",
          company_url: "",
          dept_type: "",
          emp_type: "",
          edu_level: "",
          experience: "",
          salary: "",
          location: "",
          mode: "",
          skills: [],
          candidate_profile: "",
          job_description_md: "",
          // job_summary: "",
          qualifications: [],
          // responsibility: [],
          // about_company: "",
          company_location: "",
          // perks: [],
          // pre_requisites: [],
          no_of_rounds: "",
          no_of_open_positions: "",
        });
        setSelectedChips([]);
        setLocalGeneratedSkills([]);
        setCurrentStep(1);
        setHiringModalOpen(false);

        // Refresh job listings
        await dispatch(getPostedJobs(params));
      }
    } catch (error) {
      console.error("Error submitting job:", error);
      openSnackbar("Failed to save job", "error");
    } finally {
      setSaving(false);
    }
  };

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="left"
        alignItems="left"
        minHeight="60vh"
        width="100vw"
        padding={"20px"}
      >
        <JobsCardsSkeleton />
      </Box>
    );
  }

  // Render error state
  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <Alert severity="error">
          {error}
          <Button
            onClick={() => dispatch(getPostedJobs(params))}
            sx={{ ml: 2 }}
          >
            Retry
          </Button>
        </Alert>
      </Box>
    );
  }

  // Render empty state

  return (
    <Box
      sx={{
        backgroundColor: "rgba(244, 247, 254, 1)",
        p: "10px",
        display: "flex",
        flexDirection: "row",
        // gap: "10px",s
      }}
    >
      <Box
        sx={{
          width: "75%",
          overflowY: "scroll",
          maxHeight: "90vh",
          scrollbarWidth: "none",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", gap: "10px", p: 1 }}>
          {(searchTerm ? filteredJobs : jobsToDisplay)?.length === 0 ? (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "200px",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "#666",
                  textAlign: "center",
                  fontWeight: 500,
                }}
              >
                No matching jobs found
              </Typography>
            </Box>
          ) : (
            <Grid container spacing={2}>
              {jobsToDisplay?.map((job, index) => (
                <Grid
                  item
                  xs={12}
                  sm={viewMode === "grid" ? 6 : 12}
                  md={viewMode === "grid" ? 4 : 12}
                  key={job?.id}
                  // sx={{ display: "flex" }}
                   sx={{ display: "flex", justifyContent: "center", alignItems: "stretch" }}
                >
                  <Helmet>
                    <meta property="og:title" content={`${job.role} at ${job.company_name}`} />
                    <meta property="og:description" content={`${job.location} | ${job.experience}`} />
                    <meta property="og:image" content={job.company_logo} />
                    <meta property="og:url" content={`${window.location.origin}/job-description/${job.id}`} />
                  </Helmet>
                  <motion.div
                    // key={job?.id} // Use unique key for each job
                    initial="hidden"
                    animate={isVisible ? "visible" : "hidden"}
                    exit="exit"
                    variants={cardVariants}
                    transition={{
                      delay: index * 0.1, // Staggered animation for each card
                      duration: 0.5,
                    }}
                    // style={{ width: "100%" }}
                    style={{ width: "100%", display: "flex", justifyContent: "center" }}
                  >
                    <Card
                      sx={{
                        boxShadow: 3,
                        borderRadius: 2,
                        width: "100%", // Take full width in list view
                        // minHeight: "400px",
                        // height: viewMode === "grid" ? "min(60vh, 420px)" : "auto", // Adjust height in list view
                        // position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        p: 3,
                        justifyContent: "space-between",

                        transition: "transform 0.2s, box-shadow 0.2s",
                        "&:hover": {
                          // transform: "translateY(-5px)",
                          // boxShadow: 5,
                          border: "0px solid #0044C6",
                        },
                      }}
                    >
                      <Box>
                        <Box
                          sx={{
                            // position: "absolute",
                            top: 2,
                            right: 8,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: 1,
                          }}
                        >
                          {viewMode == "list" && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  color:
                                    job?.status?.toLowerCase() === "open"
                                      ? "green"
                                      : "red",
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  padding: "4px 12px",
                                  borderRadius: "4px",
                                  bgcolor:
                                    job?.status?.toLowerCase() === "open"
                                      ? "rgba(0, 128, 0, 0.1)"
                                      : "rgba(255, 0, 0, 0.1)",
                                }}
                              >
                                {job?.status}
                              </Typography>
                            </Box>
                          )}
                          <Typography
                            variant="caption"
                            color="gray"
                            sx={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            {renderPostedDate(job?.date_posted)}
                          </Typography>
                          <IconButton
                            size="small"
                            aria-label="share"
                            onClick={(e) => {
                            e.stopPropagation(); // Prevent card click when sharing
                            handleJobShare(job);
                          }}
                            sx={{ fontSize: "16px" }}
                          >
                            {job?.status == "open" ? (
                              <ShareIcon fontSize="small" />
                            ) : (
                              ""
                            )}
                          </IconButton>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flex: 1,
                          }}
                        >
                          {/* <Link to={`/job-description/${job.id}`}> */}
                          <Box
                            sx={{ cursor: "pointer" }}
                            onClick={() => handleSingleJobClick(job?.id)}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%",
                                gap: 0.5,
                                mb: 0.5,
                                position: "relative",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  flex: 1,
                                }}
                              >
                                <img
                                  width="70px"
                                  height="70px"
                                  src={
                                    job?.company_logo ||
                                    "https://www.shutterstock.com/image-vector/image-icon-trendy-flat-style-600nw-643080895.jpg"
                                  }
                                  alt="Placeholder Logo"
                                  style={{ objectFit: "contain" }}
                                />
                              </Box>

                              {/* Only show status in grid view */}
                              {viewMode !== "list" && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      color:
                                        job?.status?.toLowerCase() === "open"
                                          ? "green"
                                          : "red",
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      padding: "4px 12px",
                                      borderRadius: "4px",
                                      bgcolor:
                                        job?.status?.toLowerCase() === "open"
                                          ? "rgba(0, 128, 0, 0.1)"
                                          : "rgba(255, 0, 0, 0.1)",
                                    }}
                                  >
                                    {job?.status == "close"
                                      ? "Closed"
                                      : job?.status}
                                  </Typography>
                                </Box>
                              )}
                            </Box>

                            <Box>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: 600,
                                  fontSize: "16px",
                                  color: "black",
                                }}
                              >
                                {job?.role}
                              </Typography>
                              {/* Company Name */}
                              <Typography
                                variant="body2"
                                sx={{
                                  textAlign: "start",
                                  fontSize: "16px",
                                  color: "#00000099",
                                }}
                              >
                                {job?.company_name}
                              </Typography>
                            </Box>
                            {/* </Box> */}

                            {/* Job Details */}
                            <Grid
                              container
                              sx={{
                                display: "grid",
                                gridTemplateColumns:
                                  viewMode === "list"
                                    ? "repeat(4, 1fr)"
                                    : "repeat(2, 1fr)",
                                gap: viewMode === "list" ? 1 : 0.5,
                                my: "3px",
                                // p: 1,
                                overflowX:
                                  viewMode === "list" ? "auto" : "visible",
                                "&::-webkit-scrollbar": { display: "none" },
                                scrollbarWidth: "none",
                              }}
                            >
                              {/* Education Level */}
                              <Grid item>
                                <Typography
                                  variant="body2"
                                  display="flex"
                                  alignItems="center"
                                  sx={{
                                    color: "#000000DE",
                                    fontSize: "12px",
                                    // bgcolor: '#f5f5f5',
                                    p:
                                      viewMode === "list"
                                        ? "6px 12px"
                                        : "5px 5px",
                                    borderRadius: 1,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    minWidth:
                                      viewMode === "list" ? "150px" : "auto",
                                    height: "32px",
                                  }}
                                >
                                  <SchoolIcon
                                    fontSize="small"
                                    sx={{
                                      mr: 1,
                                      color: "#0000008A",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                  {job?.edu_level || "Not Specified"}
                                </Typography>
                              </Grid>

                              {/* Experience */}
                              <Grid item>
                                <Typography
                                  variant="body2"
                                  display="flex"
                                  alignItems="center"
                                  sx={{
                                    color: "#000000DE",
                                    fontSize: "12px",
                                    // bgcolor: '#f5f5f5',
                                    p:
                                      viewMode === "list"
                                        ? "6px 12px"
                                        : "5px 5px",
                                    borderRadius: 1,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    minWidth:
                                      viewMode === "list" ? "150px" : "auto",
                                    height: "32px",
                                  }}
                                >
                                  <WorkOutline
                                    fontSize="small"
                                    sx={{
                                      mr: 1,
                                      color: "#0000008A",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                  {job?.experience || "Not Specified"}
                                </Typography>
                              </Grid>

                              {/* Salary */}
                              <Grid item>
                                <Typography
                                  variant="body2"
                                  display="flex"
                                  alignItems="center"
                                  sx={{
                                    color: "#000000DE",
                                    fontSize: "12px",
                                    // bgcolor: '#f5f5f5',
                                    p:
                                      viewMode === "list"
                                        ? "6px 12px"
                                        : "5px 5px",
                                    borderRadius: 1,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    minWidth:
                                      viewMode === "list" ? "150px" : "auto",
                                    height: "32px",
                                  }}
                                >
                                  <CurrencyRupeeIcon
                                    fontSize="small"
                                    sx={{
                                      mr: 1,
                                      color: "#0000008A",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                  {formatSalary(job?.salary) || "Not Specified"}
                                </Typography>
                              </Grid>

                              {/* Location */}
                              <Grid item>
                                <Typography
                                  variant="body2"
                                  display="flex"
                                  alignItems="center"
                                  sx={{
                                    color: "#000000DE",
                                    fontSize: "12px",
                                    // bgcolor: '#f5f5f5',
                                    p:
                                      viewMode === "list"
                                        ? "6px 12px"
                                        : "5px 5px",
                                    borderRadius: 1,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    minWidth:
                                      viewMode === "list" ? "150px" : "auto",
                                    height: "32px",
                                  }}
                                >
                                  <LocationOn
                                    fontSize="small"
                                    sx={{
                                      mr: 1,
                                      color: "#0000008A",
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                  {job?.location?.split(",")[0].trim() ||
                                    "Not Specified"}
                                </Typography>
                              </Grid>
                            </Grid>

                            {/* <Typography
                              variant="body2"
                              sx={{
                                mb: 1.2,
                                fontSize: "14px",
                                color: "#000000DE",
                                mt: 1,
                              }}
                            >
                              <DescriptionOutlinedIcon
                                fontSize="small"
                                sx={{
                                  // mr: 0.5,

                                  color: "#0000008A",
                                  width: "16px",
                                  height: "16px",
                                }}
                              />
                              {(() => {
                                try {
                                  // No need to parse, job?.responsibility is already an array
                                  const responsibilities = job?.responsibility;

                                  if (
                                    Array.isArray(responsibilities) &&
                                    responsibilities?.length > 0
                                  ) {
                                    const text = responsibilities.join(" "); // Convert array to string
                                    return (
                                      text.split(" ").slice(0, 10).join(" ") +
                                      "..."
                                    ); // Limit to 10 words
                                  }
                                } catch (error) {
                                  let text =
                                    job?.responsibility ||
                                    "Responsibility details not available.";

                                  // Ensure text is a string before using split
                                  if (Array.isArray(text)) {
                                    text = text.join(" "); // Convert array to string
                                  }

                                  return (
                                    text.split(" ").slice(0, 10).join(" ") +
                                    "..."
                                  ); // Limit to 10 words
                                }
                              })()}
                              <span
                                style={{
                                  color: "#007BFF",
                                  cursor: "pointer",
                                  marginLeft: 5,
                                }}
                              >
                                ...More
                              </span>
                            </Typography> */}

                            <Box
                              // sx={{
                              //   p: 0.2,
                              //   maxHeight:
                              //     viewMode === "list" ? "40px" : "50px", // Reduced to 2 lines (24px per line)
                              //   overflow: "hidden",
                              //   position: "relative",
                              // }}
                              sx={{
                              p: 0.2,
                              maxHeight: viewMode == "list" ? "7vh": "10vh",
                              overflowY: "scroll", 
                              scrollbarWidth: "none",
                            }}
                            >
                              {job?.skills ? (
                                <Box
                                  sx={{
                                    width: "100%",
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "8px",
                                    "& > *": {
                                      maxWidth:
                                        viewMode === "list" ? "120px" : "none",
                                    },
                                    maskImage:
                                      "linear-gradient(to bottom, black 80%, transparent 100%)",
                                  }}
                                >
                                  {parseSkillsArray(job?.skills).map(
                                    (skill, index, arr) => {
                                      const maxSkills =
                                        viewMode === "list" ? 8 : 4;
                                      if (index >= maxSkills) {
                                        if (index === maxSkills) {
                                          return (
                                            <Typography
                                              key="more"
                                              variant="body2"
                                              sx={{
                                                color: "#007BFF",
                                                cursor: "pointer",
                                                fontWeight: "500",
                                                fontSize: "12px",
                                                lineHeight: "20px",
                                              }}
                                            >
                                              +{arr.length - maxSkills} more
                                            </Typography>
                                          );
                                        }
                                        return null;
                                      }
                                      return (
                                        <Typography
                                          key={index}
                                          variant="body2"
                                          sx={{
                                            color: "gray",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            fontSize: "12px",
                                            lineHeight: "20px",
                                            backgroundColor: "#f5f5f5",
                                            padding: "2px 8px",
                                            borderRadius: "4px",
                                          }}
                                        >
                                          {skill.trim()}
                                        </Typography>
                                      );
                                    }
                                  )}
                                </Box>
                              ) : (
                                <Typography
                                  variant="body2"
                                  sx={{ color: "gray" }}
                                >
                                  Skills not specified.
                                </Typography>
                              )}
                            </Box>
                            <hr />
                            <Box>
                              <Typography
                                sx={{
                                  textAlign: "center",
                                  width: "100%",
                                  overflow: "hidden",
                                  color: "gray",
                                  fontSize: "11px", // Smaller font for clarity
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "left",
                                  gap: "5px", // Adds space between icon and text
                                }}
                              >
                                <GroupsIcon sx={{ fontSize: "22px" }} />
                                {job?.applicantStats?.total
                                  ? `${job?.applicantStats.total} applied`
                                  : "No Applicants"}
                              </Typography>
                            </Box>
                            {/* </Link> */}
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          width: viewMode === "list" ? "20%" : "100%",
                          display: "flex",
                          justifyContent: "center", // Adjust alignment for responsiveness
                          flexDirection: "row", // Keep items in a row
                          // position: "relative",
                          padding: 0.5,
                          gap: 2,
                          flexWrap: "wrap", // Allow wrapping for smaller screens
                        }}
                      >
                        <>
                          <Button
                            variant="contained"
                            color="primary"
                            // onClick={(e) => {
                            //   e.stopPropagation();
                            //   setEditingJob(job);

                            // }}
                            onClick={(e) => handleEditJobClick(job, e)}
                            size="small"
                            sx={{
                              width: "25%",
                              minWidth: "60px",
                              flexGrow: 1,
                              textAlign: "center",
                            }}
                          >
                            Edit
                          </Button>
                          <Button
                            variant="contained"
                            onClick={(e) => {
                              e.stopPropagation();
                              // handleJobDelete(job?.id);
                              handleAnalyticClick(job?.id);
                            }}
                            size="small"
                            sx={{
                              minWidth: "60px",
                              flexGrow: 1,
                              color: "white",
                              width: "25%",
                              textAlign: "center",
                              ":hover": {
                                color: "white",
                              },
                            }}
                          >
                            Analytics
                          </Button>
                        </>
                      </Box>
                    </Card>
                  </motion.div>
                  
                  {/* <Helmet>
                                      <meta property="og:url" content={job.url} />
                                      <meta property="og:title" content={job.title} />
                                      <meta property="og:description" content={job.description} />
                                      <meta property="og:image" content={job.image} />
                                    </Helmet> */}
                </Grid>
              ))}
            </Grid>
          )}

          {showDeleteModal && (
            <DeleteLightBox
              LightBoxCloseFunction={setShowDeleteModal}
              Title="Job"
              Label="Are you sure you want to delete this job?"
              DeleteFunction={handleConfirmDelete}
              clearFields={() => setJobToDelete(null)}
            />
          )}

          <ShareProfile
            open={shareProfileConfig.open}
            onClose={shareProfileConfig.onClose}
            qrCodeUrl={shareProfileConfig.qrCodeUrl}
            showQr={shareProfileConfig.showQr}
            profileType={shareProfileConfig.profileType}
            handleSuccess={shareProfileConfig.handleSuccess}
            handleFailure={shareProfileConfig.handleFailure}
            shareData={shareProfileConfig?.shareData}
          />

          <CompanySelectionModal
            open={showCompanySelection}
            onClose={() => setShowCompanySelection(false)}
            companies={displayCompanies}
            experiences={displayCompanies}
            onSelectCompany={handleCompanySelection}
          />

          <PostingJobModal
            open={hiringModalOpen}
            onClose={() => setHiringModalOpen(false)}
            currentStep={currentStep}
            hiringData={hiringData}
            companyLogo={companyLogo}
            menuOptions={menuOptions}
            hiringInputValue={hiringInputValue}
            localGeneratedSkills={localGeneratedSkills}
            selectedChips={selectedChips}
            isLoadingSkills={isLoadingSkills}
            isLoadingDescription={isLoadingDescription}
            handleHiringModalClose={() => setHiringModalOpen(false)}
            handleHiringInputChange={handleHiringInputChange}
            // handleKeyDown={handleKeyDown}
            handleHiringAddChip={handleHiringAddChip}
            handleChipToggle={handleChipToggle}
            handleHiringChipDelete={handleHiringChipDelete}
            handleEditSkillClick={handleEditSkillClick}
            handleEditResponseClick={handleEditResponseClick}
            handleBack={handleBack}
            handleNext={handleNext}
            handleClose={() => setIsPostingModalOpen(false)}
            handleHiringSubmit={handleHiringSubmit}
            setHiringInputValue={setHiringInputValue}
            setCurrentStep={setCurrentStep}
            isEditing={!!hiringData?.id}
          />
        </Box>
        <Box
          sx={{ display: "flex", justifyContent: "center", padding: "20px" }}
        >
          {totalPages > 1 && (
            <CandidatePagination
              totalPages={totalPages}
              currentPage={pageCount + 1}
              onPageChange={handlePage}
            />
          )}
        </Box>
      </Box>
      <Box
        sx={{
          // position: "sticky",
          top: "110px", // Distance from the top of the viewport
          alignSelf: "flex-start", // Ensures it stays at the start of the parent container
          width: "30%", // Set appropriate width for the JobOpenings component
          // zIndex: 1000, // Ensure it stays above other elements if necessary
          overflowY: "scroll",
          maxHeight: "90vh",
          scrollbarWidth: "none",
          padding: "10px",
        }}
      >
        {/* <FilterComponent
          filterOptions={{
            ...JobsData?.filters,
            // Include currently applied filters
            ...(Object.keys(appliedFilters).length > 0 && {
              currentFilters: appliedFilters,
            }),
          }}
          onApply={handleApplyFilters}
          onClear={handleClearFilters}
        /> */}
        <GlobalSearchCandidates />
      </Box>
    </Box>
  );
};

export default AllJobs;
